import React from 'react';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

import { DatePickerField, MCText, SearchTextField } from 'src/components/basic';
import { TableLibrary } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import constants from 'src/constants';

import {
  remCss,
  number,
  countFormat,
  getSelectLabel,
  lang,
  permissions,
  withRouter
} from 'src/helpers';

import model from './model';
import ShortInfo from 'src/components/user/ShortInfo';
import LANG_CONST from '../../../../helpers/lang/const';

class MoneyStatistics extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    if (!model.initFlag) {
      model.refresh();
      model.initFlag = true;
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.initFlag = false;
  }

  onSearchChange = (key, value) => {
    if (value?.toString() === model.input(key)?.toString()) return;
    model.setStateSilent({ [key]: value, pageIndex: 0 });
    model.setListStateSilent({ items: [], total: 0 }, model.getCurrentId());
    model.refresh();
  };

  onSearchTextChange = (text) => {
    model.setStateSilent({ search: text, pageIndex: 0 });
    model.handleChangeSearch(text);
    if (!text) {
      model.setListStateSilent({ items: [], total: 0 }, 'search');
      model.refresh();
    }
  };

  render() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();
    let { total = 0 } = model.getCurrent();

    const columns = [
      {
        label: 'Name',
        sort: { sortKey: 'name' },
        resize: true,
        minWidth: '150',
        renderCell: (item) => {
          return (
            <ShortInfo
              user={item}
              specialist={[]}
              to={permissions.PAGES.ADMIN_MESSAGES_USER_PAGE.match(item.id)}
            />
          );
        }
      },
      {
        label: LANG_CONST.email_phone,
        resize: true,
        minWidth: '250',
        width: '25%',
        renderCell: (item) => (
          <div className={'mc-flex-5-col'}>
            <MCText label={item.email} numberOfLines={1} heading size={18} weight={500} />
            <MCText
              label={formatPhoneNumberIntl((item.phoneNumber || '').toString())}
              numberOfLines={1}
              heading
              size={18}
              weight={400}
            />
          </div>
        )
      },
      {
        label: 'Specialist',
        resize: true,
        renderCell: (item) => getSelectLabel(constants.general.specialist, item.specialist)
      },
      {
        label: 'Degree',
        resize: true,
        width: '5%',
        minWidth: '80',
        renderCell: (item) => item.school
      },
      {
        label: 'Appointments',
        resize: true,
        width: '10%',
        minWidth: '80',
        renderCell: (item) => countFormat(item.appointmentCount)
      },
      {
        label: 'Treatments',
        resize: true,
        width: '10%',
        minWidth: '80',
        renderCell: (item) => countFormat(item.treatmentCount)
      },
      {
        label: 'Earnings',
        minWidth: '150',
        cellStyles: { textAlign: 'end' },
        renderCell: (item) => {
          let result = [];
          Object.keys(item.wallets || {}).forEach((key) => {
            if (item.wallets[key] > 0) result.push(number.format(item.wallets[key]) + ' ' + key);
          });
          if (result.length > 0) {
            return (
              <div>
                {result.map((r) => (
                  <div key={r}>{r}</div>
                ))}
              </div>
            );
          } else {
            return '0';
          }

          // return '$' + number.format(item.wallet || 0);
        }
      }
    ];

    return (
      <div className={'mc-container-content mc-money-statistics'}>
        <div className={'mc-container-content__header'}>
          <span className={'mc-grow'}>{lang.t('Money  Statistics')}</span>
          <div className={'mc-flex'}>
            <SearchTextField
              template={'2'}
              width={300}
              placeholder={'Search'}
              onChange={this.onSearchTextChange}
              value={searchQuery}
            />
            <DatePickerField
              style={{ minWidth: remCss(170) }}
              template={6}
              icontype={2}
              placeholder={'Start Date'}
              placement={'bottom-center'}
              name={'startDate'}
              value={model.input('startDate')}
              onChange={this.onSearchChange}
              invalid={{}}
            />
            <DatePickerField
              style={{ minWidth: remCss(170) }}
              template={6}
              icontype={2}
              placeholder={'End Date'}
              placement={'bottom-center'}
              name={'endDate'}
              value={model.input('endDate')}
              onChange={this.onSearchChange}
              invalid={{}}
            />
          </div>
        </div>
        <div className={'mc-container-content__body'}>
          <div className={'mc-container-content__body-content'} style={{ marginTop: remCss(25) }}>
            <TableLibrary
              loading={loading}
              noResults={noResults}
              searchQuery={searchQuery}
              sortBy={model.state.sortBy}
              selectedPage={model.state.pageIndex}
              total={total}
              limit={model.listLimit}
              onSortChange={(sortBy) => {
                model.handleChange('sortBy', sortBy);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              onSetPage={(v) => {
                model.handleChange('pageIndex', v);
                model.setListState({ items: [] }, model.getCurrentId(), null, true);
                model.loadMore();
              }}
              columns={columns}
              data={items}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(MoneyStatistics);
